export default __webpack_public_path__ + "static/Entenda0109-0e4adf924ed3287220d8197a7075eabe.jpg";